import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";

const MetaSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark">
        <h5 className="mb-0 text-dark">Meta Information</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <Form.Control
                type="text"
                value={data.title}
                onChange={(e) => handleChange('title', e.target.value)}
                placeholder="Enter meta title"
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={data.description}
                onChange={(e) => handleChange('description', e.target.value)}
                placeholder="Enter meta description"
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MetaSection;
